import { FilterItem } from "@/modules/common/filters";
import useOptionsQuery from "./useOptionsQuery";
import { ENERGY_DISTRIBUTORS_ENDPOINTS, EnergyDistributorsService } from "@/service/api/energy-distributors";
import { Pagination } from "@/modules/common/types/Pagination";
import { EnergyDistributorResponse } from "@/service/response/energy-distributors";

interface UseEnergyDistributorOptionsParams {
  currentValue?: FilterItem;
  enabled?: boolean;
}

const useEnergyDistributorOptions = ({ currentValue, enabled }: UseEnergyDistributorOptionsParams = {}) => {
  return useOptionsQuery<Pagination<EnergyDistributorResponse>>(
    [ENERGY_DISTRIBUTORS_ENDPOINTS.LIST],
    (page) => EnergyDistributorsService.list({ page, limit: 20 }),
    (page) => page.values.map((distributor) => ({ value: distributor.id, label: distributor.name })),
    (lastPage) => (lastPage.metadata.currentPage < lastPage.metadata.totalPages ? lastPage.metadata.currentPage + 1 : undefined),
    "Erro ao carregar distribuidoras.",
    currentValue,
    enabled,
  );
};

export default useEnergyDistributorOptions;
